
// 任务内容类型
const taskContentType = {
    1:{
        text:'目录',
        icon:''
    },
    2:{
        text:'课程',
        icon:''
    },
    3:{
        text:'考试',
        icon:''
    },
    4:{
        text:'直播',
        icon:''
    },
    5:{
        text:'线上实训',
        icon:''
    },
    6:{
        text:'表单',
        icon:''
    },
    7:{
        text:'练习',
        icon:''
    },
    8:{
        text:'线下实训',
        icon:''
    },

};
const courseType = {
    1:{
        text:'视频',
        icon:'course-video'
    },
    2:{
        text:'音频',
        icon:'course-audio'
    },
    3:{
        text:'文档',
        icon:'course-doc'
    },
    4:{
        text:'图片',
        icon:'course-image'
    },
    6:{
        text:'scorm',
        icon:'scorm'
    },
    10:{
        text:'练习',
        icon:'course-lianxi'
    },
    11:{
        text:'直播间',
        icon:'zhiboke'
    },
    12:{
        text:'实训间',
        icon:'shixunke'
    }
}
// 任务类型
const taskType = {
    0:{
        text:'未分类'
    },
    1:{
        text:'必修课'
    },
    2:{
        text:'选修课'
    },
    3:{
        text:'公开课'
    }
}
// 线下实训培训结果
const trainingResult = {
    0:{
        text:'实训成绩：不合格',
    },
    1:{
        text:'实训成绩：合格',
    },
    2:{
        text:'已预约',
    }
}



export default {
    taskType,
    courseType,
    taskContentType,
    trainingResult
}